class QuantityManager {
  constructor(container) {
    // Store DOM elements
    this.container = container;
    this.quantityInput = container.querySelector('.quantity-input');
    this.decreaseBtn = container.querySelector('.decrease');
    this.increaseBtn = container.querySelector('.increase');
    this.buyNowBtn = container.querySelector('.buy-now-btn');
    this.variantId = container.dataset.variantId;
    this.baseUrl = `https://sunwarrior.com/cart/${this.variantId}:`;

    // Bind event handlers
    this.handleDecrease = this.handleDecrease.bind(this);
    this.handleIncrease = this.handleIncrease.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);

    // Initialize event listeners
    this.initializeEventListeners();
  }

  initializeEventListeners() {
    this.decreaseBtn.addEventListener('click', this.handleDecrease);
    this.increaseBtn.addEventListener('click', this.handleIncrease);
    this.quantityInput.addEventListener('change', this.handleInputChange);
  }

  updateQuantity(newQuantity) {
    const validQuantity = Math.max(1, newQuantity);
    this.quantityInput.value = validQuantity;
    this.buyNowBtn.href = `${this.baseUrl}${validQuantity}`;
  }

  handleDecrease() {
    const currentValue = parseInt(this.quantityInput.value) || 1;
    this.updateQuantity(currentValue - 1);
  }

  handleIncrease() {
    const currentValue = parseInt(this.quantityInput.value) || 1;
    this.updateQuantity(currentValue + 1);
  }

  handleInputChange(e) {
    const newValue = parseInt(e.target.value) || 1;
    this.updateQuantity(newValue);
  }
}

// Initialize all quantity containers when the DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  // Find all quantity containers and initialize a new QuantityManager for each
  const containers = document.querySelectorAll('.quantity-container');
  containers.forEach(container => new QuantityManager(container));
});